/**
 * BonsFilterChips — Chips de filtre horizontal pour le fil d'activité des bons.
 * Remplace les sélecteurs déroulants par des puces colorées + compteurs live.
 *
 * Filtres proposés :
 *  - all       : Tous les bons du mois (hors annulés — accessibles via modale agent)
 *  - pending   : Uniquement en attente (pending_manager + pending_director)
 *  - authorized: Uniquement autorisés
 *  - today     : Bons créés aujourd'hui
 */
import React from "react";
import { Layers, Clock, ShieldCheck, Sun } from "lucide-react";

const CHIPS = [
  { id: "all", label: "Tous", Icon: Layers, tone: "slate" },
  { id: "pending", label: "À valider", Icon: Clock, tone: "amber" },
  { id: "authorized", label: "Autorisés", Icon: ShieldCheck, tone: "emerald" },
  { id: "today", label: "Ce jour", Icon: Sun, tone: "sky" },
];

const BonsFilterChips = ({ value = "all", onChange, counts = {}, dataTestId = "bons-filter-chips" }) => {
  return (
    <div className="flex items-center gap-1.5 flex-wrap py-1" data-testid={dataTestId}>
      {CHIPS.map(({ id, label, Icon, tone }) => {
        const active = value === id;
        const n = counts[id] ?? 0;
        return (
          <button
            key={id}
            onClick={() => onChange && onChange(id)}
            data-testid={`${dataTestId}-chip-${id}`}
            className={`
              inline-flex items-center gap-1.5 h-7 px-2.5 rounded-full text-[11.5px] font-semibold transition-all
              ${active
                ? `bg-${tone}-500/25 text-${tone}-100 border border-${tone}-400/60 shadow-md shadow-${tone}-500/10`
                : `bg-slate-800/60 text-slate-400 border border-slate-700 hover:border-${tone}-500/40 hover:text-${tone}-200`}
            `}
          >
            <Icon className="w-3 h-3" />
            <span>{label}</span>
            {n > 0 && (
              <span className={`ml-0.5 inline-flex items-center justify-center min-w-4 h-4 px-1 rounded-full text-[9.5px] font-black tabular-nums ${
                active ? `bg-${tone}-500/40 text-${tone}-50` : "bg-slate-700 text-slate-300"
              }`}>
                {n}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default BonsFilterChips;
